import React, { useEffect, useState } from "react";
import axiosStrapiInstance from "../../axiosStrapi";
import { FaAngleDown, FaAngleUp } from "react-icons/fa6";
import CustomHeading from "./CustomHeading";
import faqImg from "../../assets/faq.svg";
import CustomContent from "./CustomContent";

const CustomFaqs = ({ type = "Landing" }) => {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosStrapiInstance.get("/api/faqs?populate=*");
        const result = response?.data?.data?.filter(
          (item) => item?.type === type
        );
        setFaqs(result || []);
      } catch (error) {
        console.error("Error fetching data from Strapi:", error);
      }
    };
    fetchData();
  }, []);

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <div className="py-10 px-[4%] 2xl:px-[8%] ">
      <CustomHeading
        text={"Some "}
        customImg={faqImg}
        heartHeight="60px"
        heartWidth="60px"
        spanText={"FAQS"}
        heartPosition="absolute"
        spanTextColor="#eab308"
        smTextSize="32px"
        textSize="60px"
        margin="my-3"
        heartMarginLeft="10px"
      />

      <div className="space-y-4">
        {faqs.map((item, index) => (
          <div
            key={index}
            className={` transition-all duration-400 border-gray-500 rounded-xl ${
              openIndex === index ? "bg-[#F7D09E]" : "border-b"
            }`}
          >
            <button
              className="w-full text-left p-4 flex justify-between items-center font-medium text-lg "
              onClick={() => toggleFAQ(index)}
            >
              {item.Question}
              <span>
                {openIndex === index ? (
                  <FaAngleUp className="text-red-900" />
                ) : (
                  <FaAngleDown className="text-red-900" />
                )}
              </span>
            </button>
            {openIndex === index && (
              <CustomContent
                text={item?.Answer}
                padding="p-4"
                textSize="16px"
                leading="22px"
                textColor="#374151"
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomFaqs;
